import { z } from 'zod'
import { isValidPhone, normalizePhone } from './phone'

export const joinRequestSchema = z.object({
  gym_slug: z.string().min(1, 'gym_slug is required').max(100),
  user_email: z
    .string()
    .email('Invalid email address')
    .max(200)
    .transform((v) => v.toLowerCase()),
  user_first_name: z
    .string()
    .min(1, 'First name is required')
    .max(100)
    .transform((v) => v.trim()),
  user_last_name: z
    .string()
    .min(1, 'Last name is required')
    .max(100)
    .transform((v) => v.trim()),
  user_phone: z
    .string()
    .optional()
    .nullable()
    .transform((v) => (v ? v.trim() : null))
    // Optional here because a guest may leave it out; a member's request is
    // refused without one in the handler, which is where the caller is known.
    .refine((v) => !v || isValidPhone(v), { message: 'Enter a valid phone number' })
    .transform((v) => (v ? normalizePhone(v) : null)),
  user_date_of_birth: z
    .string()
    .min(1, 'Date of birth is required')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date of birth must be YYYY-MM-DD')
    .refine((v) => new Date(v) < new Date(), { message: 'Date of birth must be in the past' }),
})

export type JoinRequestInput = z.infer<typeof joinRequestSchema>
